/**
 * Diagonal DRAFT watermark overlay — used on read-only views (e.g. SharedView)
 * when the underlying assessment has not been unlocked.
 *
 * Pure CSS — applied as a pointer-events:none layer over the content; doesn't
 * affect interaction with the page beneath.
 */
export default function DraftWatermarkOverlay({ children, label = "DRAFT — UPGRADE TO REMOVE" }) {
  return (
    <div className="relative" data-testid="draft-watermark-wrap">
      {children}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 overflow-hidden select-none"
        style={{ zIndex: 5 }}
      >
        {/* Repeating diagonal stripes of the watermark text */}
        <div
          className="absolute inset-0 flex flex-wrap items-center justify-center gap-y-[12vh]"
          style={{
            transform: "rotate(-22deg)",
            transformOrigin: "center",
            opacity: 0.085,
          }}
        >
          {Array.from({ length: 16 }).map((_, i) => (
            <span
              key={i}
              className="block w-full text-center font-display font-extrabold tracking-[0.15em] text-slate-900 dark:text-slate-100"
              style={{ fontSize: "clamp(2.6rem, 6vw, 5.2rem)", lineHeight: 1 }}
            >
              {label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
